// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-module--footer--1lE8L","contactInfo":"index-module--contact-info--2IsP3","copywrite":"index-module--copywrite--ET2Gw"};